import FormSection from "./FormSection";

export default class FormData {
    public title: string = "";
    public subText: string = ""; 
    public needsCaptcha: boolean = false;
    public sections: FormSection[] = [];
}